/**
 * 页面分页导航栏组件
 * @author wangdi
 */


/*================================================================================================*//*

 ### 功能说明
 分页导航条组件
 #### 使用
 config => { }
 new PageIndexNav(config)

 *//*==============================================================================================*/


/**
 * 分页加载组件
 * @module PageIndexNav
 */
import $wd from '../../utils';
// import $wd from '/packages/utils';

let htmlTemplate = require("./assets/views/template-page-index.html");

//=========================================================
//  参数说明 & 默认参数
//=========================================================
/**
 * 参数说明 & 默认参数
 * @memberof module:PageIndexNav
 * @type object
 */
let defaultOptions = {
    //----------------------------------
    //  功能配置
    //----------------------------------
    // 导航栏容器
    container: null,
    // 页面总数
    totalPage: 1,
    // 当前页面
    curPage: 1,
    // 显示总数
    maxViewNum: 10,
    // 换页回调
    callback: function () {
    },
    autoHidden: false,
    //----------------------------------
    //  视图模板
    //----------------------------------
    // 视图模板 > 总数量标记元素
    totalElem: null,
    // 视图模板 > 整体模板
    navBarTemplate: htmlTemplate,
    templateElem: null,
    // 视图模板 > 首页
    firstElem: null,
    // 视图模板 > 首页
    lastElem: null,
    // 视图模板 > 下一页
    nextElem: "",
    // 视图模板 > 上一页
    previousElem: "",
    // 视图模板 > 页码（普通状态）
    normalElem: null,
    // 视图模板 > 页码（选中状态）
    activeElem: null
};

function createTemplate(template) {
    if ($wd.isString(template) && $wd.createElementByHtml(template))
        return $wd.createElementByHtml(template);
    if ($wd.isElement(template))
        return template;
    if (template == null)
        return null;
    return $wd.createElementByHtml(template);
}

/**
 * 分页导航组件
 * @param {Object} config - 基础配置对象
 * @param {element} config.container           - 导航栏容器元素
 * @param {number=} [config.curPage=1]         - 当前页码
 * @param {number=} [config.totalPage=1]       - 总页数
 * @param {number=} [config.maxViewNum=10]     - 显示页码数
 * @param {object=} config.listLoader          - 绑定的ListLoader
 * @param {function=} config.callback          - 页码点击回调函数，参数为点击的页面编号{number}
 * @param {element=} config.totalElem          - 视图模板 > 总数量标记元素
 * @param {element=} config.templateElem       - 视图模板 > 整体模板
 * @param {element=} config.firstElem          - 视图模板 > 首页
 * @param {element=} config.nextElem           - 视图模板 > 下一页
 * @param {element=} config.previousElem       - 视图模板 > 上一页
 * @param {element=} config.normalElem         - 视图模板 > 页码（普通状态）
 * @param {element=} config.activeElem         - 视图模板 > 页码（选中状态）
 * @constructor
 * @alias module:PageIndexNav
 * @example
 *
 * // 导航栏
 * let pageListNav = new PageIndexNav({
     *    listLoader: pageListLoader,
     *    navBarTemplate : $wd('[data-template="navbarAll"]')[0],
     *    container: $wds('#navListContainerElem'),
     *    callback: function(pageNum) {
     *        pageListLoader.skipPage(pageNum);
     *    },
     *    totalElem:$('#totalCountElem')[0]
     * });
 */
let PageIndexNav = function (config) {

    // 参数合并
    let options = $wd.objClone(defaultOptions);
    this.options = options = $wd.objCover(options, config);


    // 重置分页元素目标
    if (!$wd.isElement(options.container)) {
        options.container = document.createElement('div');
        document.body.appendChild(options.container);
        console.warn("Warning:分页导航组件没有指定容器，默认扔在Body上了");
    }
    this.navUlElem = options.container;

    // 视图元素
    let templateElem = document.createElement('div');
    if ($wd.isElement(options.navBarTemplate)) {
        templateElem = options.navBarTemplate;
    } else if ($wd.isString(options.navBarTemplate)) {
        templateElem = $wd.createElementByHtml(options.navBarTemplate);
    }
    if ($wd.isElement(createTemplate(options.container))) {
        this.containerElem = createTemplate(options.container);
    } else if (templateElem.querySelector('[data-template="container"]')) {
        this.containerElem = templateElem.querySelector('[data-template="container"]');
    } else if (templateElem.getAttribute('data-template') == 'container') {
        this.containerElem = templateElem.cloneNode(true);
        this.containerElem.innerHTML = "";
    }
    this.totalElem = options.totalElem;

    // 编号元素模板 > 默认状态
    this.midNumElemTemplate = createTemplate(options.normalElem) || templateElem.querySelector('[data-template="normal"]') || createTemplate('<button type="button" style="background-color:white"></button>');

    // 编号元素模板 > 激活状态
    this.midNumAcitveElemTemplate = createTemplate(options.activeElem) || templateElem.querySelector('[data-template="active"]') || createTemplate('<button type="button" style="background-color:red"></button>');

    // 第一页 | 上一页  | 下一页
    this.nextElem = createTemplate(options.nextElem) || templateElem.querySelector('[data-template="next"]');
    if (!$wd.isElement(this.nextElem)) {
        this.nextElem = this.midNumElemTemplate.cloneNode(true);
        this.nextElem.textContent = "下一页";
    }
    this.previousElem = createTemplate(options.previousElem) || templateElem.querySelector('[data-template="previous"]');
    if (!$wd.isElement(this.nextElem)) {
        this.previousElem = this.midNumElemTemplate.cloneNode(true);
        this.previousElem.textContent = "上一页";
    }

    // 默认无效 > 第一页
    this.firstElem = createTemplate(options.firstElem) || templateElem.querySelector('[template="first"]');
    this.lastElem = createTemplate(options.lastElem) || templateElem.querySelector('[template="last"]');

    // 显示个数
    this.maxNavIconNumber = options.maxViewNum;

    // 当前页面位置
    this.curNumPosition = options.curPage;

    // 总分页数量
    this.totalPage = options.totalPage;

    // 页面图标点击回调函数
    this.pageNumCallback = options.callback;

    // 绑定列表
    let me = this;
    if (options.listLoader && options.listLoader.addUpdateListener) {
        options.listLoader.addUpdateListener(/**
         @param {{curPage,totalPage,totalRow}} pageInfo
         */function (pageInfo) {
            me.curNumPosition = pageInfo.curPage;
            me.totalPage = pageInfo.totalPage;
            me.totalCount = pageInfo.totalRow;
            // 总页数显示
            if ($wd.isElement(me.totalElem)) {
                me.totalElem.textContent = me.totalCount;
            }
            me.adjustNavBarStatus();
        });
    }
    this.adjustNavBarStatus();
};

PageIndexNav.prototype = {
    /**
     * 初始化
     * @param {Number} totalPage 页面总数
     * @param {Number} currentPage 当前页面
     * @memberof module:PageIndexNav#
     */
    init: function (totalPage, currentPage) {
        // 设置分页总数
        this.totalPage = totalPage;
        this.curNumPosition = currentPage ? currentPage : 1;
        this.adjustNavBarStatus();
    },
    /**
     * 绑定列表分页加载组件
     * @param {object} listLoader 分页加载组件的实例
     * @param {function} listLoader.addUpdateListener 加载器添加监听方法
     * @memberof module:PageIndexNav#
     */
    bindList: function (listLoader) {
        let me = this;
        listLoader && listLoader.addUpdateListener(function (e) {
            me.curNumPosition = e.curPage;
            me.totalPage = e.totalPage;
            me.adjustNavBarStatus();
        });
    },
    /**
     * 创建导航栏元素
     * @param {Number} pageNumber 页面编号
     * @param {Boolean=} active 是否为活动页面
     * @returns {Element}
     * @memberof module:PageIndexNav#
     */
    createSubNavElem: function (pageNumber, active) {
        let navBtnElem = null, me = this;
        if (active) {
            navBtnElem = this.midNumAcitveElemTemplate.cloneNode(true);
        } else {
            navBtnElem = this.midNumElemTemplate.cloneNode(true);
        }
        let textElem = (function findFirstChildElem(elem) {
            if (elem.children && elem.children[0]) {
                return findFirstChildElem(elem.children[0]);
            }return elem;
        })(navBtnElem);
        textElem.innerHTML = pageNumber;
        // 点击换页
        navBtnElem.onclick = function () {
            me.curNumPosition = pageNumber;
            me.pageNumCallback(pageNumber);
            me.adjustNavBarStatus();
        };
        return navBtnElem;
    },
    /**
     * 调整导航条状态
     * @memberof module:PageIndexNav#
     */
    adjustNavBarStatus: function () {
        // 中间选项列表片段
        let midLiFragment = document.createDocumentFragment();
        let me = this;
        // 只有一页隐藏容器
        if (this.totalPage <= 1 && this.options.autoHidden) {
            $wd.hideElem(this.navUlElem);
        } else {
            $wd.showElem(this.navUlElem);
        }
        // 开头
        if ($wd.isElement(this.firstElem)) {
            if (this.curNumPosition != 1 && this.curNumPosition > 8) {
                let headLiElem = this.firstElem.cloneNode(true);
                headLiElem.onclick = function () {
                    me.curNumPosition = 1;
                    me.pageNumCallback(1);
                    me.adjustNavBarStatus();
                };
                midLiFragment.appendChild(headLiElem);
            }
        }
        // 上一页
        if ($wd.isElement(this.previousElem)) {
            if (me.curNumPosition - 1 >= 1) {
                let previousLiElem = this.previousElem.cloneNode(true);
                previousLiElem.onclick = function () {
                    me.curNumPosition = me.curNumPosition - 1;
                    me.pageNumCallback(me.curNumPosition);
                    me.adjustNavBarStatus();
                };
                midLiFragment.appendChild(previousLiElem);
            }
        }
        // 中间列表
        let start = this.curNumPosition - this.maxNavIconNumber / 2 < 1 ? 1 : this.curNumPosition - this.maxNavIconNumber / 2;
        let end = start + this.maxNavIconNumber;
        for (let i = start; i < end && i <= this.totalPage; i++) {
            let subNavElem = this.createSubNavElem(i);
            if (i == this.curNumPosition) {
                subNavElem = this.createSubNavElem(i, true);
            }
            midLiFragment.appendChild(subNavElem);
        }
        // 最后一页
        if ($wd.isElement(this.lastElem)) {
            if (this.curNumPosition + 1 <= this.totalPage - 4) {
                let lastElem = this.lastElem.cloneNode(true);
                lastElem.onclick = function () {
                    me.curNumPosition = me.totalPage;
                    me.pageNumCallback(me.curNumPosition);
                    me.adjustNavBarStatus();
                };
                midLiFragment.appendChild(lastElem);
            }
        }
        // 下一页
        if ($wd.isElement(this.nextElem)) {
            if (this.curNumPosition + 1 <= this.totalPage) {
                let nextLiElem = this.nextElem.cloneNode(true);
                nextLiElem.onclick = function () {
                    me.curNumPosition = me.curNumPosition + 1;
                    me.pageNumCallback(me.curNumPosition);
                    me.adjustNavBarStatus();
                };
                midLiFragment.appendChild(nextLiElem);
            }
        }
        // 装配
        this.navUlElem.innerHTML = "";
        this.navUlElem.appendChild(midLiFragment);
    }
};


// module.exports = PageIndexNav;
export default PageIndexNav;